// extracted by mini-css-extract-plugin
export default {"saveBtnWrapper":"GeneralSettings_saveBtnWrapper__dVH0D","help":"GeneralSettings_help__41rLO"};